<template>
  <span
    @click="close()"
    data-test="base-alert-close"
  >
    <b-alert
      v-bind="$attrs"
      v-on="$listeners"
      :dismissible="dismissible"
      :class="{ 'alert-sticky' : sticky }"
      data-test="base-alert"
    >
      <slot />
    </b-alert>
  </span>
</template>

<script>
let timeout;
export default {
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
    autoDismiss: {
      type: Number,
      default: 0,
    },
  },
  updated() {
    const allowedToDismiss = !(['danger', 'warning'].includes(this.$attrs.variant));

    if (this.autoDismiss && allowedToDismiss) {
      timeout = window.setTimeout(() => {
        this.$emit('dismissed');
      }, this.autoDismiss * 1000);
    }

    if (!this.$attrs.variant) {
      clearTimeout(timeout);
    }
  },
  computed: {
    dismissible() {
      return this.$attrs.variant !== 'success';
    },
  },
  methods: {
    close() {
      this.$emit('dismissed');
      clearTimeout(timeout);
    },
  },
};
</script>


<style lang="scss">
.alert-sticky {
  position: fixed !important;
  z-index: 9999;
  top: 8px;
  transform: translateX(-50%);
  left: 50%;
  word-break: break-word;
}
</style>
